<div class="ziro-admin-page-content">
  <div class="col-md-10 offset-md-1">
    <ziro-breadcrumbs>
      <ziro-breadcrumb-card-item>
        <div [innerHTML]="'tkey;admin.order_numbers.check_number_portability.about.description' | escapeHtml"></div>
      </ziro-breadcrumb-card-item>
    </ziro-breadcrumbs>
    <ziro-loading-block [hidden]="!isLoading"></ziro-loading-block>

    @if (!isLoading) {
      <ziro-check-number-portability-form
        [entity]="formEntity"
        (ziroFormsUpdate$)="onFormUpdate($event)"
        [existingPortInDraftNumbers]="existingPortInDraftNumbers"
      ></ziro-check-number-portability-form>
    }
  </div>
</div>
<ziro-bottom-nav></ziro-bottom-nav>
